import { useQuery } from "@tanstack/react-query";
import { useApi } from "~/hooks/use-api";
import { useProduct } from "~/contexts/product-context";

export const useProductRaw = () => {
  const api = useApi();
  const { product } = useProduct();
  const productId = product?.id;

  return useQuery({
    queryKey: ["product-raw", productId],
    queryFn: () => api.products.getProductRaw(productId!),
    enabled: !!productId,
  });
};
